// extracted by mini-css-extract-plugin
export default {"root":"SectionLoader_root_Y5h6n","fill":"SectionLoader_fill_bBd3m","overlay":"SectionLoader_overlay_OThh_","spinner":"SectionLoader_spinner_q7GW1","spin":"SectionLoader_spin_iaJHR"};